import { useGroups } from './useGroups';

export function useShouldShowNoGroupCard() {
  const { groups, loading } = useGroups();
  return { show: !loading && groups.length === 0, loading, refetchTrigger: groups.length };
}
